import { render, staticRenderFns } from "./VocationsModal.vue?vue&type=template&id=28833b1c&scoped=true&"
import script from "./VocationsModal.vue?vue&type=script&lang=js&"
export * from "./VocationsModal.vue?vue&type=script&lang=js&"
import style1 from "./VocationsModal.vue?vue&type=style&index=1&id=28833b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28833b1c",
  null
  
)

export default component.exports